module.exports = __webpack_public_path__ + "static/media/logo.26cbda4c.png";